export default {
  password: {
    changeButton: 'Change password',
    titleChangeDialog: 'Change password',
    changeDialog: {
      oldPassword: 'Old password',
      password: 'New password',
      confirm: 'Password confirmation',
      rules: {
        lowercase: 'Lowercase',
        uppercase: 'Uppercase',
        digit: 'Digit',
        caracters: 'Caracters',
        special: 'Special',
      },
    },
    confirmationChange: 'Password successfully changed',
    confirmationMailSent: 'Email sent',
    expire: {
      title: 'Link expired',
      text: 'This link has expired, please go to the forgot password section to re-request a password change.',
    },
  },
}
